import { useState, useContext } from "react";
import "../contactus/contactusform.css";
import "./contactusproduct.css";
import CustomAlert from "../customAlert/CustomAlert";
import { LanguageContext } from "../../context/LanguageContext";

const PoojaFormProduct = () => {
  const { t } = useContext(LanguageContext);

  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    city: "",
    role: "homeowner",
  });

  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ type: "", message: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setAlert({ type: "", message: "" });

    const requestEmail = {
      name: formData.fullName,
      email: formData.email,
      mobile: formData.phone,
      message: `${formData.role} from ${formData.city}`,
      productURL: window.location.href,
      role: formData.role,
      browserInfo: {
        language: navigator.language,
        platform: navigator.platform,
        screenHeight: window.screen.height,
        screenWidth: window.screen.width,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        userAgent: navigator.userAgent,
        country: {
          ip: "",
          network: "",
          version: "",
          city: formData.city,
          region: "",
          country: "",
        },
      },
    };

    try {
      const response = await fetch(
        "/api/contact/sendemail",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestEmail),
        }
      );

      if (response.ok) {
        const data = await response.json();
        setAlert({
          type: "success",
          message: t("alertMessages.successMessageContact"),
        });
      } else {
        setAlert({
          type: "error",
          message: t("alertMessages.errorMessageContact"),
        });
      }
    } catch (error) {
      setAlert({
        type: "error",
        message: t("alertMessages.serverErrorContact"),
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <form className="contact-card" onSubmit={handleSubmit}>
        <h2 className="contact-title">
          <span>{t("contactUsForm.talkToExpert")}</span> {t("contactUsForm.forFree")}
        </h2>

        <CustomAlert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ type: "", message: "" })}
        />

        <div className="form-groups">
          <label>{t("contactUsForm.fullName")} *</label>
          <input
            type="text"
            name="fullName"
            placeholder="Enter your name"
            value={formData.fullName}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-groups">
          <label>{t("contactUsForm.email")} *</label>
          <input
            type="email"
            name="email"
            placeholder="Enter your email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-groups">
          <label>{t("contactUsForm.phone")} *</label>
          <div className="phone-wrapper">
            <div className="country-code">
              🇮🇳 <span>+91</span>
            </div>
            <input
              type="tel"
              name="phone"
              placeholder="12345-67890"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-groups">
          <label>{t("contactUsForm.city")} *</label>
          <input
            type="text"
            name="city"
            placeholder="Enter your city"
            value={formData.city}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-groups">
          <label>{t("contactUsForm.tellUsMessage")} *</label>

          <div className="radio-box">
            <label className="radio-item">
              <input
                type="radio"
                name="role"
                value="homeowner"
                checked={formData.role === "homeowner"}
                onChange={handleChange}
              />
              <span className="custom-radio" /><div>{t("contactUsForm.homeOwnerMessage")}</div>
            </label>

            <label className="radio-item">
              <input
                type="radio"
                name="role"
                value="designer"
                checked={formData.role === "designer"}
                onChange={handleChange}
              />
              <span className="custom-radio" />
              <div>{t("contactUsForm.designerMessage")}</div>
            </label>
          </div>
        </div>

        <button className="submit-btn" disabled={loading}>
          {loading ? t("constants.sending") : t("contactUsForm.contactUsFree")}
        </button>
      </form>
    </div>
  );
};

export default PoojaFormProduct;
